import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";
import { rootRouteRef } from "./routes";

export const agentPoliciesPlugin = createPlugin({
  id: "agent-policies",
  routes: {
    root: rootRouteRef,
  },
});

export const AgentPoliciesPage = agentPoliciesPlugin.provide(
  createRoutableExtension({
    name: "AgentPoliciesPage",
    component: () =>
      import("./components/AgentPoliciesPage").then((m) => m.AgentPoliciesPage),
    mountPoint: rootRouteRef,
  })
);
